//region [IMPORT]

// === CONSTANTS ===
import { FAILURE_CODE, SUCCESS_CODE } from 'constants/general';

//#endregion

//-----------------------------------------------------------------
function validate(content, validation_info) {
  //-----------------------------------------------------------------
  const has_validation = !!validation_info;
  const has_content    = content !== '';

  if( !has_validation || !has_content ) {
    return { content, status: SUCCESS_CODE };
  }

  validation_info = normalizeValidationInfo( validation_info );

  const result = format( content, validation_info );

  if (result.status !== FAILURE_CODE && (validation_info.Min !== '' || validation_info.Max !== '')) {
    handleMinMax(result, validation_info.Min, validation_info.Max, validation_info.ClearValueWithBadFormat);
  }

  return result;
};

//-----------------------------------------------------------------
function normalizeValidationInfo( info ) {
  //-----------------------------------------------------------------
  // Set defaults
  const normalized_info = {
    Max : null ,
    Min : null ,
  };

  // Max
  if (info.Max && info.Max !== '') {
    normalized_info.Max = parseFloat( info.Max );
  }

  // Min
  if (info.Min && info.Min !== '') {
    normalized_info.Min = parseFloat( info.Min );
  }

  return normalized_info;
};

//-----------------------------------------------------------------
function format(content, validation_info) { // num, force, strict
  //-----------------------------------------------------------------
  const result = {
    content: content,
    message: '',
    status: SUCCESS_CODE,
  };

  try {
    const content_formatted = content.replaceAll( ',', '' );
    const content_converted = Number(content_formatted);
    if( !Number.isInteger( content_converted ) ) {
      result.status  = FAILURE_CODE;
      result.message = 'Invalid integer';
      if( validation_info.ClearValueWithBadFormat ) result.content = '';
      return result;
    }

    result.content = content_formatted;
  } catch (error) {
    console.warn( error );
  }

  return result;
};

//-----------------------------------------------------------------
function handleMinMax(result, min, max, clearValueWithBadFormat) {
  //-----------------------------------------------------------------
  const value = result.content;
  const is_below_min = min ? value < min : false;
  const is_above_max = max ? value > max : false;

  const message_min = is_below_min ? ` above ${min}` : '';
  const message_max = is_above_max ? ` below ${max}` : '';

  if( is_below_min || is_above_max ) {
    result.status = FAILURE_CODE;
    result.message = 'Value must be' + message_min + message_max;
    if( clearValueWithBadFormat ) result.content = '';
  }

  return result;
};


export { validate };